export default "__VITE_ASSET__Bs_2DqeO__"